import * as React from 'react';

import {
  FilterNodeTypeDateRangeContainer,
  FilterNodeTypeDateRangeContainerOwnProps,
} from './FilterNodeTypeDateRangeContainer';

type OwnProps = Omit<FilterNodeTypeDateRangeContainerOwnProps, 'dateOnly'>;

type Props = OwnProps;

export const FilterNodeTypeDateOnlyRange: React.FC<Props> = (props) => (
  <FilterNodeTypeDateRangeContainer {...props} dateOnly />
);

FilterNodeTypeDateOnlyRange.displayName = 'FilterNodeTypeDateOnlyRange';
